/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2NoteFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2NoteFilled({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2NoteFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 13,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2NoteFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 13"
 style={{'--as-1-1dOGYI': alignSelf,'--mt-2-1dOGYI': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1dOGYI': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1dOGYI': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1dOGYI': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1dOGYI': opacity,'--w-10-1dOGYI': typeof width === 'number' ? `${width}px` : width,'--h-11-1dOGYI': typeof height === 'number' ? `${height}px` : height,'--f-12-1dOGYI': fill,'--a-7-1dOGYI': isAnimated ? animation : "none",'--sd-8-1dOGYI': isAnimated ? strokeDashoffset : 0,'--sd-9-1dOGYI': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2NoteFilled.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M7.179 12.5H1.286C.576 12.5 0 11.924 0 11.214V1.786C0 1.076.576.5 1.286.5h9.428C11.424.5 12 1.076 12 1.786v5.892H7.714a.536.536 0 00-.535.536V12.5zm1.071-.536l3.215-3.214H8.25v3.214z"
 style={{'--f-12-1dOGYI': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}